import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import { getMockPolicies } from "../builders/getMockPolicies";
import { omniUsVipMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const lebronJames: MockPersona = {
  key: "lebronJames",
  name: "LeBron James",
  description: "🇺🇸 | Single Enthusiast+ policy | HDC 1.5 VIP | No alerts/autopay successful",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: getMockPolicies("apex123"),
        canada: [],
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981376"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: 4, // TODO: Is this VIP?
      }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "lebron@james.com",
            firstName: "LeBron",
            middleName: "",
            lastName: "James",
            mailingAddress: {
              line1: "4200 Metropolitan Dr",
              line2: "",
              city: "Cleveland",
              state: "OH",
              postalCode: "44135-1840",
              country: "USA",
            },
            preferredPhone: "4409810043",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000018",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniUsVipMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
